import {
	isAuthorizationEnforced,
	isLowAuthorization,
	useAutorizaceStore,
} from '@gov-nx/store';

/**
 * Resolves the authorization level configured for a single service and derives
 * the flags consumers care about. The level semantics themselves live in the
 * shared `authorizationLevel` predicates so presentation (here) and the runtime
 * handoff (`onInitAuthorization`) read the same source of truth.
 *
 * - `isLowAuthorization` — the service uses low (`NIZKA`) authorization, i.e. an
 *   explicit consent checkbox must be shown.
 * - `isAuthorizationEnforced` — authorization is enforced at all (`NIZKA` or
 *   `VYSOKA`); used e.g. to prefix the submit button with "Autorizovat a …".
 */
export const useServiceAuthorization = (serviceName: string) => {
	const getServiceAuthorizationType = useAutorizaceStore(
		'getServiceAuthorizationType'
	);
	const authorizationLevel = getServiceAuthorizationType(serviceName);

	return {
		isLowAuthorization: isLowAuthorization(authorizationLevel),
		isAuthorizationEnforced: isAuthorizationEnforced(authorizationLevel),
	};
};
